import { COMPONENT_TYPE, INPUT_COMPONENT_TYPE } from '@abiglobalhealth/go-types'
import { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { setFulfillmentUserAddress } from '@/api/user'
import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { useConsultation } from '@/hooks/useConsultation'
import { useFormErrors } from '@/hooks/useFormErrors'
import { useLoading } from '@/hooks/useLoading'
import { useUser } from '@/hooks/useUser'
import { requiredString } from '@/utils/zod'

const zodSchema = z.object({
  address: requiredString
})

export const DefaultForm = () => {
  const { t } = useTranslation()
  const { showLoading, hideLoading } = useLoading()
  const { user } = useUser()
  const { updateConsultation } = useConsultation()
  const { addFormError } = useFormErrors()

  const handleConfirm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const formData = new FormData(e.currentTarget)
    try {
      zodSchema.parse({
        address: formData.get('address') || ''
      })
    } catch (err) {
      if (err instanceof z.ZodError) {
        for (const error of err.issues) {
          addFormError(error.path.join('.'), error.message)
        }
      } else {
        console.error(err)
      }

      return
    }

    showLoading()

    const { consultation: updatedConsultation } = await setFulfillmentUserAddress({
      uniqueId: user?.data?.uniqueId!,
      address: formData.get('address') as string
    })
    updateConsultation(updatedConsultation)

    hideLoading()
  }

  return (
    <div className="flex flex-col gap-4 p-4">
      <p>{t('prescription.patient.address')}</p>

      <form id="user-address-form" onSubmit={handleConfirm}>
        <div className="flex flex-col py-4">
          <Input
            componentType={COMPONENT_TYPE.INPUT}
            id="address"
            tabIndex={0}
            type={INPUT_COMPONENT_TYPE.TEXTAREA}
            textKey={'delivery.address.address'}
            placeholder={'inputs.address.placeholder'}
            value={user?.data?.address}
          />
        </div>

        <Button>{t('button.confirm')}</Button>
      </form>
    </div>
  )
}
